import React, { useState, useEffect } from 'react';
import { supabase } from '../api/supabase';
import { Box, Typography, Button, TextField, Dialog, DialogActions, DialogContent, DialogTitle, List, ListItem, ListItemText, IconButton, Paper, Alert } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import Loader from '../components/common/Loader';

const ClientsPage = () => {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [currentClient, setCurrentClient] = useState({ id: null, name: '', phone: '', stamp_count: 0 });
  const [error, setError] = useState('');

  useEffect(() => { fetchClients(); }, []);

  const fetchClients = async () => {
    setLoading(true);
    const { data, error } = await supabase.from('clients').select('*').order('name');
    if (error) setError('Falha ao buscar clientes.');
    else setClients(data);
    setLoading(false);
  };

  const handleOpen = (client = null) => {
    if (client) {
      setIsEditing(true);
      setCurrentClient(client);
    } else {
      setIsEditing(false);
      setCurrentClient({ id: null, name: '', phone: '', stamp_count: 0 });
    }
    setOpen(true);
  };

  const handleClose = () => { setOpen(false); setError(''); };

  const handleSave = async () => {
    if (!currentClient.name || !currentClient.phone) {
      setError('Nome e Telefone são obrigatórios.');
      return;
    }
    const clientData = {
      name: currentClient.name,
      phone: currentClient.phone,
      stamp_count: Number(currentClient.stamp_count)
    };
    const { error } = isEditing
      ? await supabase.from('clients').update(clientData).eq('id', currentClient.id)
      : await supabase.from('clients').insert([clientData]);

    if (error) setError(`Falha ao salvar. O telefone já pode estar cadastrado.`);
    else { handleClose(); fetchClients(); }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCurrentClient(prev => ({ ...prev, [name]: value }));
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h5">Clientes VIP</Typography>
        <Button variant="contained" startIcon={<AddIcon />} onClick={() => handleOpen()}>Novo Cliente</Button>
      </Box>
      
      {loading ? <Loader /> : (
        <Paper>
          <List>
            {clients.map(c => (
              <ListItem key={c.id} secondaryAction={<IconButton edge="end" onClick={() => handleOpen(c)}><EditIcon /></IconButton>}>
                <ListItemText
                  primary={c.name}
                  secondary={`Tel: ${c.phone} | Carimbos: ${c.stamp_count}`}
                />
              </ListItem>
            ))}
          </List>
        </Paper>
      )}

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>{isEditing ? 'Editar Cliente' : 'Novo Cliente'}</DialogTitle>
        <DialogContent>
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          <TextField autoFocus margin="dense" name="name" label="Nome do Cliente" type="text" fullWidth value={currentClient.name} onChange={handleChange} />
          <TextField margin="dense" name="phone" label="Telefone" type="tel" fullWidth value={currentClient.phone} onChange={handleChange} />
          <TextField margin="dense" name="stamp_count" label="Carimbos" type="number" fullWidth value={currentClient.stamp_count} onChange={handleChange} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancelar</Button>
          <Button onClick={handleSave}>{isEditing ? 'Salvar' : 'Adicionar'}</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ClientsPage;